import fetchApi from 'services/api/connector';

export const fetchProjects = () => fetchApi('projects');
export const fetchProject = (id) => fetchApi(`projects/${id}`);
export const createProject = (name) => fetchApi('projects', { method: 'POST', data: { name } });
export const updateProject = (id, name) => fetchApi(`projects/${id}`, { method: 'PATCH', data: { name } });
export const deleteProject = (id) => fetchApi(`projects/${id}`, { method: 'DELETE' });
